var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.tags.length
    ? _c(
        "div",
        {
          class: [
            "filter-nav",
            { "filter-nav--open": _vm.isOpen, "filter-nav--top": _vm.isTop }
          ],
          on: {
            mouseenter: function($event) {
              return _vm.$emit("toggle")
            },
            mouseleave: function($event) {
              return _vm.$emit("close")
            }
          }
        },
        [
          _c(
            "btn",
            {
              staticClass: "filter-nav__current",
              attrs: { type: "button", tag: "control" },
              nativeOn: {
                click: function($event) {
                  return _vm.$emit("toggle")
                }
              }
            },
            [_vm._v("\n\t\t" + _vm._s(_vm.current.title) + "\n\t")]
          ),
          _c("div", { ref: "navBody", staticClass: "filter-nav__body" }, [
            _c(
              "ul",
              { staticClass: "filter-nav__list" },
              _vm._l(_vm.tags, function(item) {
                return _c(
                  "li",
                  { staticClass: "filter-nav__list-item" },
                  [
                    _c(
                      "nuxt-link",
                      {
                        key: item.id,
                        class: [
                          "filter-nav__list-link",
                          {
                            "filter-nav__list-current":
                              item.tag === _vm.current.tag
                          }
                        ],
                        attrs: { to: _vm.basePath + _vm.setPath(item.tag) },
                        nativeOn: {
                          click: function($event) {
                            return _vm.$emit("close")
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t" + _vm._s(item.title) + "\n\t\t\t\t"
                        )
                      ]
                    )
                  ],
                  1
                )
              }),
              0
            )
          ])
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5dbeab80", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5dbeab80","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/FilterNav.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-5dbeab80","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/FilterNav.vue
// module chunks = 0